import builder from '../builder';
import HeadphonesCustomerSupportHuman from '../../streamline-icons/bold/headphones-customer-support-human.svg';

export default builder(
  'IconHeadphonesCustomerSupportHumanBold',
  HeadphonesCustomerSupportHuman,
);
